const p=["jpeg","jpg","png","gif"],g=["mp4"];export{p as IMAGE_FILE_VIBER,g as VIDEO_FILE_VIBER};
//# sourceMappingURL=fileTypesViber.js.map
